import { getStepKindInfo } from '@sb/remote-control/util/stepKindInfo';
import type { StepKind } from '@sb/routine-runner';

import type { Diagnostic, ValidationRule } from '../../types';
import { diag } from '../../util/ruleHelpers';

export const DecoratorValidation: ValidationRule = {
  id: 'steps.Decorator',
  appliesTo: 'step',
  run: ({ routine, stepId }) => {
    if (!stepId) return [];

    const step = routine.steps.find((s) => s.id === stepId);
    if (!step) return [];

    let isDecorator = false;

    try {
      isDecorator =
        getStepKindInfo(step.stepKind as StepKind).isDecorator === true;
    } catch {
      // Unknown step kind — not a decorator
      return [];
    }

    if (!isDecorator) return [];

    const children = step.children ?? [];

    if (children.length === 0) {
      const d: Diagnostic = diag({
        code: 'ui.invalidConfiguration',
        message: 'Tap row below to add step.',
        stepId,
        sourceRule: 'steps.Decorator',
      });

      return [d];
    }

    return [];
  },
};
